import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import clsx from 'clsx';

interface ExpandableBodyProps {
  height: number;
  expandedHeight: number;
}

const ExpandableBody = (props: React.PropsWithChildren<ExpandableBodyProps>) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div>
      <div className={'text-right'}>
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          variant={'link'}
          title="Expand View"
          type="button"
          className="p-0 mb-2 font-weight-semi-bold"
        >
          <span
            className={clsx(
              !isExpanded ? 'icon-bzm-chevron-down' : 'icon-bzm-chevron-up',
              'inline-span-style icon-xs mr-1',
            )}
          ></span>
          {isExpanded ? 'Collapse ' : 'Expand'} View
        </Button>
      </div>
      <p style={{ height: !isExpanded ? props.height : props.expandedHeight, overflow: 'auto' }}>{props.children}</p>
    </div>
  );
};

export default ExpandableBody;
